import { readSelectedAccount } from './../main/getters';
import { IEmployeeCreate, IEmployeeUpdate } from './../../interfaces/index';
import { State } from './../state';
import { EmployeesModState } from './state';
import { getStoreAccessors } from "typesafe-vuex";
import { api } from '@/api';
import { ActionContext } from 'vuex';
import { commitSetEmployees, commitSetEmployee, commitSetRoles, commitRemoveEmployee } from './mutations';
import { dispatchCheckApiError } from '../main/actions';

type MainContext = ActionContext<EmployeesModState, State>;

export const actions = {
    async getEmployees(context: MainContext) {
        try {
            const response = await api.getEmployees(context.rootState.main.token,
                context.rootState.main.selected_account); 
            if (response) {
                commitSetEmployees(context, response.data);
            }
        } catch ( error ) {
            await dispatchCheckApiError(context, error);
        }
    },
    async getEmployee(context: MainContext, id: number) {
        try {
            
            const response = await api.getEmployee(context.rootState.main.token,
                context.rootState.main.selected_account, id);
            if (response) {
                commitSetEmployee(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async addEmployee(context: MainContext, payload: IEmployeeCreate) {
        try {
            const response = await api.addEmployee(context.rootState.main.token,
                payload, context.rootState.main.selected_account);
            if (response) {
                commitSetEmployee(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async updateEmployee(context: MainContext, payload: {id: number, data: IEmployeeUpdate}) {
        try {
            const response = await api.updateEmployee(context.rootState.main.token,
                context.rootState.main.selected_account, payload.id, payload.data);
            if (response) {
                commitSetEmployee(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async removeEmployee(context: MainContext, id: number) {
        try {
            const response = await api.deleteEmployee(context.rootState.main.token,
                context.rootState.main.selected_account, id);
            if (response) {
                commitRemoveEmployee(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
        
    },
    async getRoles(context: MainContext) {
        try {
            const response = await api.getRoles(context.rootState.main.token, false);
            if (response) {
                commitSetRoles(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
};

export const { dispatch } = getStoreAccessors<EmployeesModState, State>('');

export const dispatchGetEmployees = dispatch(actions.getEmployees);
export const dispatchGetEmployee = dispatch(actions.getEmployee);
export const dispatchUpdateEmployee = dispatch(actions.updateEmployee);
export const dispatchAddEmployee = dispatch(actions.addEmployee);
export const dispatchRemoveEmployee = dispatch(actions.removeEmployee);
export const dispatchGetRoles = dispatch(actions.getRoles);